const ENV_ID = process.env.REACT_APP_ENV_ID!;
const QUESTION_DB = process.env.REACT_APP_QUESTION_DB!;
const TAG_ID = process.env.REACT_APP_TAG_DB!;
const TAG_DB = process.env.REACT_APP_TAG_DB!;

export { ENV_ID, QUESTION_DB, TAG_ID, TAG_DB };
